import React, { useState } from 'react';

const VoiceInput = ({ onResult, disabled }) => {
  const [isListening, setIsListening] = useState(false);

  const startListening = () => {
    if ('webkitSpeechRecognition' in window) {
      const recognition = new window.webkitSpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'zh-CN';

      recognition.onstart = () => setIsListening(true);
      recognition.onend = () => setIsListening(false);
      recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        onResult(transcript);
      };

      recognition.start();
    } else {
      alert('您的浏览器不支持语音输入');
    }
  };

  return (
    <button 
      className={`voice-btn ${isListening ? 'listening' : ''}`}
      onClick={startListening}
      disabled={disabled}
      title="语音输入"
      type="button"
    >
      🎤
    </button>
  );
};

export default VoiceInput; 